import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
// const API_URL = 'http://localhost:8081'

export default {
  getListDocuments: async (querys) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents`, querys)
    const response = await fetchManager(url, {
      headers: {
        'document-authorized': false
      }
    })
    return response
  },
  
  updateVisibilityDocument: async (id, data) => {
    const response = await fetchManager(`${API_URL}/DocumentManagement/api/amx/cpe/documents/visibility/${id}`, {
        method: 'PATCH',
        data,
      })
      return response
  },

  deleteDocument: async (id, querys, data) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/${id}`, querys)
    const response = await fetchManager(url, {
        method: 'DELETE',
        data,
      })
    return response
  },

  deleteFile: async (querys, errorModal) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/file/simpleDelete`, querys)
    const response = await fetchManager(url, {
        method: 'PUT'
      }, errorModal)
    return response
  },

  renameDirDocument: async (querys, errorModal) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/renameDirFile`, querys)
    const response = await fetchManager(url, {
        method: 'PATCH'
      }, errorModal)
    return response
  },

  addDocument: async (data) => {
    const response = await fetchManager(`${API_URL}/DocumentManagement/api/amx/cpe/documents`, {
      method: 'POST',
      data,
    })
    return response;
  },
  
  changeStatusDocument: async (id, data, querys) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/${id}`, querys)

    const response = await fetchManager(url, {
      method: 'PATCH',
      data,
    })
    return response;
  },
  
  getDetailDocument: async (id, errorModal) => {
    const response = await fetchManager(`${API_URL}/DocumentManagement/api/amx/cpe/documents/${id}`,{},errorModal)
    return response
  },
  
  updateDocument: async (data) => {
    const response = await fetchManager(`${API_URL}/DocumentManagement/api/amx/cpe/documents`, {
      method: 'PUT',
      data,
    })
    return response;
  },

  reOrderDocument: async (data) => {
    const response = await fetchManager(`${API_URL}/DocumentManagement/api/amx/cpe/documents/order`,
    {
      method: 'PATCH',
      data,
    })
    return response
  },
  getListAnexos: async (querys) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/anexos`, querys)
    const response = await fetchManager(url)
    return response
  },

  simpleUpload: async (data, querys) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/file/simpleUpload`, querys)

    const response = await fetchManager(url, {
      method: 'PUT',
      data,
    })
    return response;
  },

  getReportTotalUsersReaders: async (idDocument, querys) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/readers/total/${idDocument}`, querys)
    const response = await fetchManager(url)
    return response
  },

  getReportDetailUsersReaders: async (idDocument, querys) => {
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/readers/${idDocument}`, querys)
    const response = await fetchManager(url)
    return response
  },

  getReportDetailUsersReadersDownload: async (idDocument, querys) => {
    const errorModal = { show: 'no' }
    const url = urlQueryData(`${API_URL}/DocumentManagement/api/amx/cpe/documents/readers/detail/${idDocument}`, querys)
    const response = await fetchManager(url, { isFile: true }, errorModal)
    return response
  },

  getPuestosDocument: async (idDocument) => {
    const response = await fetchManager(`${API_URL}/DocumentManagement/api/amx/cpe/documents/puestos/${idDocument}`)
    return response
  },
}